<template>
  <div class="container">
    <div class="head">
      <p>憑藉澳覓龐大的用戶數量以及穩定的使用頻率，</p>
      <p>澳覓幫助企業以及商家進行極具成本效益的品牌曝光，</p>
      <p>並可鏈接至商家頁或者商品頁，提升交易額。</p>
      <p>
        同時，澳覓結合其資源優勢為合作方訂製活動內容，聯動線上/線下進行多方位的宣傳。
      </p>
    </div>
    <div class="mid">
      <p class="name">澳覓平台的線上推廣曝光日均達30W+</p>
      <p class="des">
        廣告類型包括線上廣告：開屏廣告、首頁彈窗、頂通、中通、主題廣告、企業專區、首頁浮標、精準推送、訂單狀態頁、分享紅包、“我的”頁面廣告、完成支付後頁面廣告、Facebook、WeChat等優質廣告位。線下廣告：外送宣傳廣告、外賣POS機廣告、充電寶宣傳廣告。另外，澳覓還可以訂製專屬活動，能滿足不同場景、不同類型的營銷需求。
      </p>
      <ul>
        <li>
          <img src="../../assets/image/coop-icon1.png" alt="" />
        </li>
        <li>
          <img src="../../assets/image/coop-icon2.png" alt="" />
        </li>
        <li>
          <img src="../../assets/image/coop-icon3.png" alt="" />
        </li>
        <li>
          <img src="../../assets/image/coop-icon4.png" alt="" />
        </li>
        <li>
          <img src="../../assets/image/coop-icon5.png" alt="" />
        </li>
      </ul>
    </div>
    <div class="case" style="background-color: #f0eff4">
      <div class="title">
        <p class="sub">COOPERATION CASES</p>
        <p class="head">合作案例</p>
      </div>
      <div class="con">
        <div class="left">
          <el-carousel
            class="banner"
            trigger="click"
            height="605px"
            arrow="never"
          >
            <el-carousel-item v-for="item in 7" :key="item">
              <img
                :src="require(`../../assets/image/phone-banner${item}.png`)"
                alt=""
              />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="right">
          <p class="right-title">線上廣告</p>
          <div class="small-red-bar"></div>
          <p class="right-sub-title">澳覓合作夥伴（部分）</p>
          <img src="../../assets/image/coop.png" alt="" />
          <p class="email">
            商務合作郵箱：aomi.ad@aomiapp.com（郵件主題註明：澳覓推廣合作）
          </p>
        </div>
      </div>
      <div class="offline-ads">
        <div class="header">
          <p class="offline-ads-title">線下廣告</p>
          <div class="small-red-bar"></div>
        </div>
        <div class="content">
          <div class="item" v-for="item in offlineAds" :key="item.prefix">
            <img
              :src="require(`../../assets/image/${item.prefix}.246_370.png`)"
              alt=""
            />
            <p class="text">{{item.text}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="partners" style="padding-bottom: 50px">
      <div class="title">
        <p class="sub">COOPERATIVE PARTNER</p>
        <p class="head">戰略合作夥伴</p>
      </div>
      <div class="content">
        <ul class="carousel-title">
          <li
            @click="changeBanner(index)"
            :class="{ active: activeIndex === index }"
            v-for="(label, index) in partners"
            :key="index"
          >
            {{ label }}
          </li>
        </ul>
        <el-carousel
          class="second-banner"
          :interval="5000"
          @change="changeBanner"
          ref="carousel"
          trigger="click"
          arrow="always"
          height="650px"
        >
          <el-carousel-item
            v-for="item in ['a', 'b', 'c', 'd', 'e', 'f']"
            :key="item"
          >
            <img
              :src="require(`../../assets/image/${item}.1200_650.png`)"
              alt=""
            />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>
<script>
import { Carousel, CarouselItem } from "element-ui"
export default {
  components: {
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  },
  data () {
    return {
      partners: [
        '銀行及支付組織', '博企', '品牌活動', '演出節目', '展覽活動', '車展'
      ],
      offlineAds: [ 
        { prefix: 'a', text: '外賣宣傳廣告' },
        { prefix: 'b', text: '外賣POS机廣告' },
        { prefix: 'c', text: '充電寶宣傳廣告' },
      ],
      activeIndex: 0
    }
  },
  methods: {
    changeBanner(index) {
      this.activeIndex = index
      this.$refs.carousel.setActiveItem(index)
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 1200px;
  margin: 125px auto 0;
  > .head {
    width: 100%;
    height: 338px;
    background: url(../../assets/image/coop-bg.png) center center no-repeat;
    background-size: 100% 100%;
    p {
      font-size: 18px;
      color: #fff;
      text-align: center;
      padding-top: 25px;
      &:first-child {
        padding-top: 90px;
      }
    }
  }
  .mid {
    margin-top: 70px;
    text-align: center;
    font-weight: 500;
    .name {
      font-size: 22px;
      color: #ff3159;
    }
    .des {
      width: 890px;
      margin: auto;
      font-size: 18px;
      line-height: 1.8;
      color: #2d2f3c;
      padding-top: 20px;
    }
    ul {
      width: 820px;
      margin: 35px auto 0;
      display: flex;
      justify-content: space-between;
      li {
        text-align: center;
        img {
          display: block;
        }
      }
    }
  }
  .case,
  .partners {
    width: 1200px;
    margin: 65px auto 0;
    padding-bottom: 57px;
    .title {
      text-align: center;
      background-color: #fff;
      padding-bottom: 65px;
      .sub {
        font-size: 14px;
        color: #ff3159;
      }
      .head {
        font-size: 30px;
        font-weight: bold;
      }
    }
    // 合作案列
    .con {
      display: flex;
      width: 890px;
      height: 630px;
      margin: auto;
      .left {
        width: 299px;
        background-color: red;
        height: 605px;
        background: url(../../assets/image/phone.png) center center no-repeat;
        background-size: 100% 100%;
        margin-top: -50px;
        overflow: hidden;
        flex-shrink: 0;
        .banner {
          width: 270px;
          height: 605px;
          margin: auto;
          padding-top: 20px;
          overflow: hidden;
          // border-radius: 30px;
          img {
            // width: 270px;
            border-radius: 30px;
          }
          /deep/ .el-carousel__button {
            width: 4px;
            height: 4px;
            border-radius: 50%;
          }
        }
      }
      .right {
        font-weight: 500;
        text-align: left;
        color: #2c3e50;
        margin: 44px 0 0 40px;
        &-title {
          font-size: 26px;
          font-family: 'PingFangSC';
          font-weight: 600;
        }
        &-sub-title {
          margin-top: 22px;
          font-size: 23px;
          font-weight: 600;
        }
        img {
          width: 659px;
          margin: 10px 0 30px;
        }
        .email,
        .tel {
          font-size: 17px;
          font-weight: 600;
        }
      }
    }
    .offline-ads {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .header {
        margin-left: 492px;
        text-align: left;
      }
      &-title {
        font-size: 26px;
        font-family: 'PingFangSC';
        font-weight: 600;
      }
      .content {
        padding: 12px 162px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .item {
          padding: 16px 12px;
          width: 268px;
          height: 444px;
          background: #ffffff;
          border-radius: 7px;
          box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.18);
          img {
            width: 100%;
          }
        }
        .text {
          font-size: 18px;
          color: #283a4d;
          font-weight: 500;
          margin-top: 16px;
        }
      }
    }
    // 合作伙伴
    .content {
      .carousel-title {
        width: 832px;
        margin: auto;
        display: flex;
        background-color: #fff;
        justify-content: space-between;
        align-items: center;
        li {
          cursor: pointer;
          font-size: 24px;
          color: #777777;
          height: 61px;
          text-align: center;
          line-height: 61px;
          &.active {
            width: 204px;
            height: 60px;
            background: #ff3159;
            color: #fff;
            border-radius: 28px 28px 0 0;
          }
        }
      }
      .second-banner {
        width: 1200px;
        margin: auto;
        /deep/ .el-carousel__button {
          width: 10px !important;
          height: 10px !important;
          border-radius: 50%;
          background-color: red !important;
        }
        img {
          width: 1200px;
        }
      }
    }

    .small-red-bar {
      width: 22px;
      height: 4px;
      margin-top: 4px;
      background: #ff3159;
    }
    
  }
}
</style>
